export default __webpack_public_path__ + "static/media/step10.90cf9a89.jpg";